import React from 'react';
import PropTypes from 'prop-types';

import useStyles from './styles';
import PlotWrapperTooltip from './PlotWrapperTooltip';


const PlotWrapper = ({
  title,
  children,
  showTooltip,
  tooltipText,
  overriddenClasses,
}) => {
  const classes = useStyles();
  return (
    <div className={overriddenClasses.plotWrapper || classes.plotWrapper}>
      {title && <div
        className={overriddenClasses.plotWrapperTitle || classes.plotWrapperTitle}
        style={{ display: 'flex', alignItems: 'center' }}
      >
        {title}
        {showTooltip && <PlotWrapperTooltip tooltipText={tooltipText} />}
      </div>}
      <div className={overriddenClasses.plotCard || classes.plotCard}>
        {children}
      </div>
    </div>
  );
};


PlotWrapper.defaultProps = {
  overriddenClasses: {},
  title: '',
  showTooltip: false,
  tooltipText: '',
};

PlotWrapper.propTypes = {
  overriddenClasses: PropTypes.objectOf(PropTypes.string),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  showTooltip: PropTypes.bool,
  tooltipText: PropTypes.string,
};

export default PlotWrapper;
